export class Mask {
  constructor() {
    this.symbols = '';
    this.partMap = [];
  }
}